import { useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import MainPagetitle from '../../../layouts/MainPagetitle';

const AuditTrail = (props) => {
  const infoForm = useRef(null);
  const [auditLogs, setAuditLogs] = useState([]);
  const [rowcount, setRowcount] = useState(0);
  const [downloading, setDownloading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({ title: '', content: '' });
  const toastConfig = {
    autoClose: 3000,
    closeButton: false,
    hideProgressBar: true,
  };

  const columns = [
    {
      dataIndex: 'createdAt',
      title: 'Created On',
      render: (text, record) => {
        if (record?.timestamp) {
          return new Date(record.timestamp).toLocaleDateString('en-GB');
        }
        return '-';
      },
    },
    {
      dataIndex: 'user',
      title: 'User',
      render: (text, record) => {
        return record?.user?.name || record?.user?.profileId || record?.user?.role || 'System';
      },
    },
    {
      dataIndex: 'userIP',
      title: 'IP Address',
    },
    {
      dataIndex: 'url',
      title: 'Call API',
    },
    {
      dataIndex: 'requestBody',
      title: 'Request Body',
      render: (text, record) => {
        return (
          <span
            className="text-primary cursor-pointer text-decoration-underline"
            onClick={() => openModal('Request Body', record?.requestBody || {})}
          >
            View
          </span>
        );
      },
    },
    {
      dataIndex: 'responseBody',
      title: 'Response Body',
      render: (text, record) => {
        return (
          <span
            className="text-primary cursor-pointer text-decoration-underline"
            onClick={() => openModal('Response Body', record?.responseBody || {})}
          >
            View
          </span>
        );
      },
    },
  ];

  const fields = [
    {
      name: 'profileId',
      label: 'Employee Id',
      placeholder: 'Please enter',
      type: 'text',
    },
    {
      name: 'customerId',
      label: 'Customer Id',
      placeholder: 'Please enter',
      type: 'text',
    },
    {
      name: 'applicationId',
      label: 'Application No.',
      placeholder: 'Please enter',
      type: 'text',
    },
    {
      name: 'loanAccountNumber',
      label: 'LAN',
      placeholder: 'Please enter',
      type: 'text',
    },
  ];

  const fetchAuditLogs = async (payload, reset) => {
    setLoading(true);
    if (!reset) {
      if (Object.keys(payload).length === 0) {
        toast.error('Please enter at least one field', toastConfig);
        setLoading(false);
        return;
      }
      props.apis
        .apiGetAuditLogs(payload)
        .then((data) => {
          setAuditLogs(data);
          setRowcount(data?.length);
          setLoading(false);
        })
        .catch(() => {
          setAuditLogs([]);
          setRowcount(0);
          setLoading(false);
        });
    } else {
      setAuditLogs([]);
      setLoading(false);
    }
  };

  const onSearch = () => {
    let data = infoForm.current.form.current.getData();
    data = Object.removeEmpty(data);
    fetchAuditLogs(data, false);
  };

  const resetSearchForm = () => {
    infoForm?.current?.form?.current?.reset();
    fetchAuditLogs({}, true);
  };

  const downloadReport = async () => {
    let data = infoForm.current?.form?.current?.getData() || {};
    data = Object.removeEmpty(data);

    if (Object.keys(data).length === 0) {
      toast.error('Please enter at least one field', toastConfig);
      return;
    }

    setDownloading(true);
    try {
      const res = await props.apis.apiGenericAuditLogsDownload(data);
      if (res) {
        const blob =
          res instanceof Blob
            ? res
            : new Blob([res], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.setAttribute(
          'download',
          `audit_report_${new Date().toISOString().slice(0, 10)}.pdf`
        );
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } else {
        toast.error('Failed to download audit report.', toastConfig);
      }
    } catch (e) {
      const errMsg = e?.response?.data?.message || e?.message || 'Something went wrong while downloading the report.';
      toast.error(errMsg, toastConfig);
    } finally {
      setDownloading(false);
    }
  };

  const openModal = (title, content) => {
    setModalData({ title, content: JSON.stringify(content, null, 2) });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <MainPagetitle
        mainTitle="Audit Trail"
        pageTitle={'Audit Trail'}
        pageIcon={typeof imagepaths !== 'undefined' ? imagepaths.reportsIconActive : ''}
      />
      <div className="container-fluid">
        <div className="card mb-4">
          <div className="card-body">
            <AppForm
              ref={infoForm}
              onSubmit={onSearch}
              className="align-items-end justify-content-end g-3"
            >
              {fields.map((field, i) => (
                <div key={i} className="col-md-6 col-lg-2 flex-grow-1">
                  <AppInput {...field} />
                </div>
              ))}
              <div className="col-12 col-sm-3 col-md-2 col-lg-1 p-0 d-flex align-items-start justify-content-center flex-grow-1">
                <button type="submit" className="btn btn-primary w-100 mb-3">
                  <span>Submit</span>
                </button>
              </div>
              <span
                type="button"
                className="clear-all text-primary m-0"
                onClick={() => resetSearchForm()}
              >
                Clear All
              </span>
            </AppForm>
          </div>
        </div>

        <div className="d-flex justify-content-end mb-3">
          <button
            type="button"
            className="btn btn-primary-transparent file_download_btn text-primary"
            onClick={downloadReport}
            disabled={downloading}
          >
            <i className="fa fa-download me-2"></i>
            {downloading ? 'Downloading...' : 'Download Report'}
          </button>
        </div>

        <div className="card">
          <div className="card-body p-0">
            <AppTable
              data={auditLogs}
              columns={columns}
              loading={loading}
              total={rowcount}
              reorder={true}
              editable={false}
              viewable={false}
              deletable={false}
            />
          </div>
        </div>
      </div>

      <Modal show={showModal} onHide={closeModal} centered>
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">{modalData.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          <pre
            className="p-3 rounded border"
            style={{
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              color: '#000',
              fontFamily: 'Poppins',
              fontWeight: 400,
              fontSize: '14px',
            }}
          >
            {modalData.content}
          </pre>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default constore(AuditTrail);
